import { render } from "./AboutFreelance.vue?vue&type=template&id=02ee39b3"
import script from "./AboutFreelance.vue?vue&type=script&lang=js"
export * from "./AboutFreelance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__